import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "payment-conditions" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "h-100 col-12 col-lg-2 py-4 d-flex flex-column position-relative flex-item w-100" }

import { useStore } from "vuex";
import { computed } from "vue";

// Components
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"

// Access the Vuex store

export default /*@__PURE__*/_defineComponent({
  __name: 'paymentConditions',
  setup(__props) {

const store = useStore();

// Computed getter from the Vuex store
const selectedPrestations = computed(() => store.getters.selectedPrestations);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (selectedPrestations.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPrestations.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index + '-' + item?.prestation?.prestIdFusion
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(PaymentCondition, {
                  isSummaryDisplay: true,
                  prestId: item.prestation.prestIdFusion,
                  paymentCondition: item.prestation.paymentCondition,
                  displayTitle: true,
                  "cancellation-date": item.prestation.cancelationUntil
                }, null, 8, ["prestId", "paymentCondition", "cancellation-date"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})